module.exports = __webpack_public_path__ + "img/img-5.c2212c02.png";